import * as React from 'react';
import { SystemIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const CategorySeoLargeIcon = ({
    size = 24,
    color = 'currentFill'
}: SystemIconType) => (
    <svg width={size}
        height={size}
        viewBox="0 0 32 32"
        fill={color}
        xmlns="http://www.w3.org/2000/svg">
        <path d="M5.334 5a.334.334 0 0 0-.333.333v13.334a1 1 0 1 1-2 0V5.333A2.334 2.334 0 0 1 5.334 3h21.333a2.334 2.334 0 0 1 2.334 2.333V16a1 1 0 1 1-2 0V5.333A.334.334 0 0 0 26.667 5H5.334Z"
            fill="#404145"/>
        <path fillRule="evenodd"
            clipRule="evenodd"
            d="M26.758 28.172a5 5 0 1 1 1.414-1.414l3.202 3.201a1 1 0 0 1-1.414 1.415l-3.202-3.202ZM21.001 24a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z"
            fill="#404145"/>
        <path d="M1.334 23a1 1 0 0 0-1 1 5 5 0 0 0 5 5h9.333a1 1 0 1 0 0-2H5.334a3 3 0 0 1-2.83-2h12.163a1 1 0 1 0 0-2H1.334Z"
            fill="#404145"/>
    </svg>
);
CategorySeoLargeIcon.displayName = 'CategorySeoLargeIcon';
export default CategorySeoLargeIcon;
